import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $title': {
      color: TextColors.light,
    },

    '& $superHeading': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    '& $title': {
      color: TextColors.dark,
    },

    '& $superHeading': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      minHeight: '35px',
      width: '100%',
    },
    columns: {
      '& .columns': {
        justifyContent: 'center',
      },
    },
    card: {},
    headerCard: {
      [muiTheme.breakpoints.up('md')]: {
        width: '50%',
      },
    },
    hasHeader: {
      paddingBottom: muiTheme.spacing(5),

      [muiTheme.breakpoints.up('md')]: {
        paddingBottom: muiTheme.spacing(9),
      },
    },
    title: {},
    superHeading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1),
      },
    },
  }),
  { name: 'GenCardListRow' },
);

export default useStyles;
